import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Box, CircularProgress, Typography } from "@mui/material";

import { BsThreeDotsVertical } from "react-icons/bs";

import { useLocation, useNavigate } from "react-router-dom";
import { formatDate, ShortenName2, ShortenName3 } from "../../../utils/const";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  removeEducationSkillValue,
  removeOfficialReferenceValue,
  removePersonalDetailsValue,
  removePreviousExperienceValue,
} from "../../../redux/internalCandidateStaticValue/internalCandidateStaticValue";
import InternalCandidateViewdrawer from "./InternalCandidateViewDrawer";
import { getAllRecruiterCandidateNextPrevious } from "../../../redux/internal-tracking/InternalTrackerSlice";

const columns = [
  {
    id: "full_name",
    label: "Candidate",
    minWidth: 100,
  },
  {
    id: "current_job_title",
    label: "Job Profile",
    minWidth: 100,
  },
  {
    id: "total_experience",
    label: "Exp",
    minWidth: 30,
  },
  {
    id: "current_location",
    label: "Location",
    minWidth: 60,
  },

  {
    id: "work_authorization",
    label: "Visa",
    minWidth: 60,
  },
  {
    id: "rate",
    label: "Expected",
    minWidth: 60,
  },
  {
    id: "active",
    label: "Status",
    minWidth: 60,
  },
  {
    id: "created_at",
    label: "Date ",
    minWidth: 60,
  },
  {
    id: "profile",
    label: "Profile",
    minWidth: 20,
  },
];

export default function PortalSubmissionTable({
  internalTrack,
  trackDetails,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
}) {
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  const [showView, setShowView] = useState(false);
  const handleCloseView = () => setShowView(false);
  const handleViewShow = () => setShowView(true);
  const [submisionRow, setSubmisionRow] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location);
  const trackStatus = useSelector((state) => state.tracker.status);

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalCandidateDetails"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "internalCandidateDetails",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1);
  };

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(allLocation());
    dispatch(removePersonalDetailsValue());
    dispatch(removeEducationSkillValue());
    dispatch(removePreviousExperienceValue());
    dispatch(removeOfficialReferenceValue());
  }, []);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const handleOnClickJobID = (column, row) => {
    if (column.id === "full_name") {
      localStorage.setItem("internalCandidateDetails", JSON.stringify({ row }));
      handleViewShow();
      setSubmisionRow(row);
    }
  };

  const handleOnClickNextPrevious = (type) => {
    if (type === "next") {
      let url = trackDetails?.data?.next;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    } else {
      let url = trackDetails?.data?.previous;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    }
  };

  return (
    <Box style={{ backgroundColor: "#fff", padding: "0" }}>
      <Paper
        sx={{
          overflow: "hidden",
        }}
      >
        <TableContainer sx={{ maxHeight: 640 }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderSpacing: "0 2px" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  style={{
                    minWidth: 50,
                    width: "20px",
                    backgroundColor: "#e5e7eb",
                    fontWeight: "600",
                    fontSize: "13px",
                    padding: "11px 14px 11px 1px",
                  }}
                >
                  <span>No.</span>
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      backgroundColor: "#e5e7eb",
                      fontWeight: "600",
                      fontSize: "13px",
                      padding: "11px 14px 11px 1px",
                    }}
                  >
                    <span
                      style={
                        column.id === "slno"
                          ? {}
                          : {
                              borderLeft: "1.5px solid #ccc",
                              padding: "7px 1px 7px 10px",
                            }
                      }
                    >
                      {column.label}
                    </span>
                  </TableCell>
                ))}
                <TableCell
                  style={{
                    width: "20px",
                    backgroundColor: "#e5e7eb",
                    fontWeight: "600",
                    fontSize: "13px",
                    padding: "11px 14px 11px 1px",
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {trackStatus === "loading" ? (
                <TableRow>
                  <TableCell colSpan={columns.length}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      py={4}
                    >
                      <CircularProgress color="info" />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : internalTrack?.length > 0 ? (
                internalTrack
                  // ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      >
                        <TableCell
                          align="center"
                          style={{
                            fontSize: "14px",
                            backgroundColor: "#f8f9fa",
                            padding: "10px 15px",
                            fontFamily: "Calibri",
                            color: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              style={{
                                fontSize: "13px",
                                backgroundColor: "#f8f9fa",
                                padding: "10px 15px",
                                fontFamily: "Calibri",
                                cursor:
                                  column.id === "full_name" ? "pointer" : "",
                                textDecoration:
                                  column.id === "full_name" ? "underline" : "",
                                color:
                                  column.id === "population"
                                    ? "#154e83"
                                    : column.id === "density"
                                    ? "#00B050"
                                    : column.id === "date"
                                    ? "#154e83"
                                    : "inherit",
                              }}
                              key={column.id}
                              align={column.align}
                              onClick={() => handleOnClickJobID(column, row)}
                            >
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : column.id === "created_at"
                                ? formatDate(value)
                                : column.id === "full_name"
                                ? ShortenName3(value)
                                : column.id === "current_job_title"
                                ? ShortenName2(value)
                                : column.id === "current_location"
                                ? getLocationById(value)
                                : column.id === "work_authorization"
                                ? getWorkAuthorization(value)
                                : column.id === "active"
                                ? value
                                  ? "Active"
                                  : "In-Active"
                                : column.id === "profile"
                                ? `${row?.filled_percentage}%`
                                : column.id === "rate"
                                ? row?.rate === null
                                  ? "Not Disclosed"
                                  : `$${row?.rate}${
                                      row?.p_tax_team?.includes("full_Time")
                                        ? "K Yearly"
                                        : " Hourly"
                                    }`
                                : column.id === "total_experience"
                                ? `${row?.total_experience}${
                                    row?.total_experience > 1
                                      ? " Years"
                                      : " Year"
                                  }`
                                : value}
                            </TableCell>
                          );
                        })}
                        <TableCell
                          style={{
                            minWidth: 10,
                            fontSize: "13px",
                            backgroundColor: "#f8f9fa",
                            padding: "10px 15px",
                            fontFamily: "Calibri",
                            color: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          <Box
                            variant="contained"
                            size="large"
                            onClick={() => {
                              // navigate("/internal-tracker-view", {
                              //   state: { row: row },
                              // });
                              handleViewShow();
                              setSubmisionRow(row);

                              localStorage.setItem(
                                "internalCandidateDetails",
                                JSON.stringify({ row })
                              );
                            }}
                          >
                            <BsThreeDotsVertical />
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length + 2} align="center">
                    <Typography
                      variant="h6"
                      style={{
                        color: "#666",
                        fontFamily: "Calibri",
                        padding: "20px",
                      }}
                    >
                      Candidate not found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={internalTrack?.length || 0}
          rowsPerPage={rowsPerPage}
          // page={page}
          page={Math.min(
            page,
            Math.max(
              0,
              Math.ceil((internalTrack?.length || 0) / rowsPerPage) - 1
            )
          )}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        {/* <Box sx={{ float: "right", padding: "10px 5px" }}>
          <GrFormPrevious
            style={
              trackDetails?.data?.previous === null
                ? {
                    fontSize: "24px",
                    cursor: "pointer",
                    marginRight: "5px",
                    cursor: "not-allowed",
                    color: "#545454",
                  }
                : { fontSize: "24px", cursor: "pointer", marginRight: "5px" }
            }
            onClick={() => handleOnClickNextPrevious("previous")}
            disabled={trackDetails?.data?.previous === null}
          />

          <GrFormNext
            style={
              trackDetails?.data?.next === null
                ? {
                    fontSize: "24px",
                    cursor: "pointer",
                    cursor: "not-allowed",
                    color: "#545454",
                  }
                : { fontSize: "24px", cursor: "pointer" }
            }
            onClick={() => handleOnClickNextPrevious("next")}
            disabled={trackDetails?.data?.next === null}
          />
        </Box> */}
      </Paper>
      <InternalCandidateViewdrawer
        handleShow={handleViewShow}
        handleClose={handleCloseView}
        show={showView}
        row={submisionRow}
      />
    </Box>
  );
}
